import { AffiliateDashboardPage } from './affiliate-dashboard.component';
import { connect } from 'react-redux';
import { 
    getAffiliateProfile, 
    getAffiliateOrders, 
    getAffiliateOrdersCount, 
    affiliateLogout 
} from './../../api/affiliate/affiliateAction';
import {
    createWithdrawal,
    getWithdrawals
} from './../../api/withdrawal/withdrawalAction';

const mapDispatchToProps = {
    getAffiliateProfile,
    getAffiliateOrders,
    getAffiliateOrdersCount,
    affiliateLogout,
    createWithdrawal,
    getWithdrawals
};

const mapStateToProps = state => ({
    isLoading: state.affiliatePage.isLoading,
    isAffiliateLoggedIn: state.affiliatePage.isAffiliateLoggedIn,
    loggedAffiliate: state.affiliatePage.loggedAffiliate,
    orders: state.affiliatePage.orders,
    orderCount: state.affiliatePage.orderCount,
    withdrawals: state.withdrawalPage.withdrawals,
    isWithdrawalLoading: state.withdrawalPage.isLoading
});

export const AffiliateDashboardContainer = connect(mapStateToProps, mapDispatchToProps)(AffiliateDashboardPage);

